import { SortByFn } from "react-table";

import cronExpressionToDayjs from "@/helpers/cronExpressionToDayjs";

import { RowData } from "../columns";

const getCronExpressionValue = (row: RowData, desc?: boolean) => {
  const maxMinSortValue = desc
    ? Number.MIN_SAFE_INTEGER
    : Number.MAX_SAFE_INTEGER;

  if (row.status === "NOT_STARTED" || row.status === "PAUSED") {
    return maxMinSortValue;
  }
  if (row.orchestrationWorkflow?.id) {
    return cronExpressionToDayjs(
      row.orchestrationWorkflow.cronExpression,
    ).unix();
  }
  if (row.syncInterval) {
    return cronExpressionToDayjs(row.syncInterval).unix();
  }
  return maxMinSortValue;
};

export const cronExprSortFn: SortByFn<RowData> = (
  rowA,
  rowB,
  columnId,
  desc,
) => {
  // Cache sort values for each row during this sort operation
  const sortValueCache =
    (cronExprSortFn as any)._sortValueCache || new WeakMap();
  (cronExprSortFn as any)._sortValueCache = sortValueCache;

  const getCachedValue = (row: any) => {
    if (!sortValueCache.has(row)) {
      sortValueCache.set(row, getCronExpressionValue(row.original, desc));
    }
    return sortValueCache.get(row);
  };

  return getCachedValue(rowA) - getCachedValue(rowB);
};
